{
  "propertyAlreadyOwnedTitle": "Eiendom {{propertyDisplay}} allerede registrert",
  "propertyAlreadyOwnedDescription": "Denne eiendommen er allerede registrert på skogeier \"{{forestOwnerName}}\" og kan ikke legges til før den fjernes fra vedkommende.",
  "unknownForestOwner": "en annen skogeier"
}
